import { CONFIG } from "../../utils/config.ts";
import { useQuery } from "@tanstack/react-query";
import { api } from "../ky.ts";
import { keycloak } from "../../auth/keycloak.ts";

export const STATUS_QUERY_KEY = "status";
const { API_URL } = CONFIG;

export function useStatusQuery() {
  return useQuery({
    queryKey: [STATUS_QUERY_KEY],
    queryFn: async () => {
      return await api.get(API_URL + "/multibank/users/me/status", { retry: 0 }).json();
    },
    enabled: keycloak.authenticated,
    refetchOnWindowFocus: true,
    retry: false,
  });
}
